import {Icon} from "@door-vision/custom-attribute-list-value-picker";
import {TranslatedString} from "@door-vision/translation-helper";
import {
  CustomAttributeFragment, CustomAttributeListOptionFragment,
  CustomAttributeType as GraphQLCustomAttributeType,
} from "../../../generated/graphql";


export enum CustomAttributeType {
  BOOLEAN = "BOOLEAN",
  DATE = "DATE",
  ENUM = "ENUM",
  NUMBER = "NUMBER",
  STRING = "STRING",
}

export interface CustomAttribute {
  id?: string
  name: string
  type: CustomAttributeType
  optional: boolean
  order?: number
  icon?: Icon

  // Filter properties
  enableAsFilter?: boolean;
  translatedFilterDescription?: TranslatedString;
  filterAllowMultiSelection?: boolean;
  filterShowInTopBar?: boolean;
  filterShowInFilterMenu?: boolean;
  filterOrder?: number;

  listOptions?: Array<CustomAttributeListOption>;
}

export interface CustomAttributeListOption {
  id: string;
  value: string;
  translatedDescription: TranslatedString;
  order?: number;
  icon?: Icon;
}

export function mapCustomAttributeListOptionFromGraphQL(attr: CustomAttributeListOptionFragment): CustomAttributeListOption {

  const translatedDescription: TranslatedString = {
    default: attr.description ?? '',
    translations: attr.translations ? JSON.parse(attr.translations) : undefined
  };

  return {
    id: attr.id,
    value: attr.value,
    order: attr.order ?? undefined,
    translatedDescription,

    icon: attr.icon ? {
      key: attr.icon.selectedKey,
      svg: attr.icon.svg,
    } : undefined
  };
}

export function mapCustomAttributeFromGraphQL(attr: CustomAttributeFragment): CustomAttribute {

  const translatedFilterDescription: TranslatedString = {
    default: attr.filterDescription ?? '',
    translations: attr.filterTranslations ? JSON.parse(attr.filterTranslations) : undefined
  };

  return {
    id: attr.id,
    name: attr.name,
    type: mapCustomAttributeTypeFromGraphQL(attr.type),
    optional: attr.optional,
    order: attr.order ?? undefined,

    // Icon
    icon: attr.icon ? {
      key: attr.icon.selectedKey,
      svg: attr.icon.svg,
    } : undefined,

    // Filter properties
    enableAsFilter: attr.enableAsFilter ?? undefined,
    filterAllowMultiSelection: attr.filterAllowMultiSelection ?? undefined,
    filterShowInTopBar: attr.filterShowInTopBar ?? undefined,
    filterShowInFilterMenu: attr.filterShowInFilterMenu ?? undefined,
    filterOrder: attr.filterOrder ?? undefined,
    translatedFilterDescription,

    listOptions: attr.listOptions ? attr.listOptions.map(mapCustomAttributeListOptionFromGraphQL) : []
  };
}

export function mapCustomAttributeTypeFromGraphQL(value: GraphQLCustomAttributeType): CustomAttributeType {
  switch (value) {
    case GraphQLCustomAttributeType.Boolean:
      return CustomAttributeType.BOOLEAN;
    case GraphQLCustomAttributeType.Date:
      return CustomAttributeType.DATE;
    case GraphQLCustomAttributeType.Enum:
      return CustomAttributeType.ENUM;
    case GraphQLCustomAttributeType.Number:
      return CustomAttributeType.NUMBER;
    case GraphQLCustomAttributeType.String:
      return CustomAttributeType.STRING;
    default:
      throw new Error(`Unknown CustomAttributeType: ${value}`);
  }
}

export function mapCustomAttributeTypeToGraphQL(value: CustomAttributeType): GraphQLCustomAttributeType {
  switch (value) {
    case CustomAttributeType.BOOLEAN:
      return GraphQLCustomAttributeType.Boolean;
    case CustomAttributeType.DATE:
      return GraphQLCustomAttributeType.Date;
    case CustomAttributeType.ENUM:
      return GraphQLCustomAttributeType.Enum;
    case CustomAttributeType.NUMBER:
      return GraphQLCustomAttributeType.Number;
    case CustomAttributeType.STRING:
      return GraphQLCustomAttributeType.String;
    default:
      throw new Error(`Unknown CustomAttributeType: ${value}`);
  }
}
